import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const attachmenttypology = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/miscellaneous/{profile}/attachment-typology',
    app: 'miscellaneous'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'miscellaneous', model: 'attachmenttypology' }
    ),
    { }
  )
)()

export { attachmenttypology, TYPES }
